import { CommonConfig } from '../../common/config';
import { DISPLAY } from '../../child/components/main/types';
import { WIDGET_ACTIONS } from '../../child/components/layers/widget/types';
import IPC from './ipc';
import Logger from '../../common/logger';
import DOM from '../../common/DOM';
import { getiOSVersion, isMobile } from '../../common/browser';

const MEDIUMBREAKPOINT = 767;

const Helpers = {
    resizeTimer: null,

    getIFrameElement() {
        const iframe = document.getElementById(CommonConfig.iFrameId);
        return iframe;
    },

    setIFrameMode(element, mode) {
        Logger.log('setMode: ' + mode);
        const documentSize = DOM.getDocumentSize();

        if (mode !== DISPLAY.FULLSCREEN && documentSize.width <= MEDIUMBREAKPOINT) {
            element.style.bottom = '50px';
        } else {
            element.style.bottom = '0';
        }

        if (mode === DISPLAY.FULLSCREEN) {
            element.style.width = documentSize.width + 'px';
            element.style.height = documentSize.height + 'px';
        } else if (mode === DISPLAY.FULLWIDTH) {
            element.style.width = documentSize.width + 'px';
        } else if (mode === DISPLAY.NONE) {
            element.style.width = '0px';
            element.style.height = '0px';
        }
    }
};

let focusedElement = null;

const repositionIframe = () => {
    const iframe = Helpers.getIFrameElement();
    if (iframe.style.position === 'absolute') {
        // fix is applied, reposiotion absolute to simulate fixed
        const body = document.getElementsByTagName('body')[0];
        const calc = document.getElementById(`${iframe.id}-calc`);
        const isLandscape =
            window.orientation !== undefined &&
            (window.orientation === 90 || window.orientation === -90);
        if (focusedElement && isLandscape) {
            const position = focusedElement.getBoundingClientRect();
            // on focus assume that keyboard layer is visible
            iframe.style.top = window.scrollY + 200 - position.top + 'px';
        } else {
            iframe.style.top =
                Math.min(
                    Math.max(0, window.scrollY + calc.clientHeight - iframe.clientHeight),
                    body.clientHeight - iframe.clientHeight
                ) + 'px';
        }
    }
};

// Source:
// https://stackoverflow.com/questions/2593139/ipad-web-app-detect-virtual-keyboard-using-javascript-in-safari

export const createIFrame = ({ id, src }) => {
    let element = document.getElementById(id);
    if (element) return element;

    const iosversion = getiOSVersion();
    const fixios = isMobile.iPad() && iosversion >= 9.0 && iosversion < 11;

    element = document.createElement('iframe');
    element.id = id;
    element.src = src;
    element.allowTransparency = 'true';
    element.allowFullscreen = 'true';
    element.frameBorder = 0;
    element.scrolling = 'no';
    element.style.position = 'fixed';
    element.style.bottom = '0px';
    element.style.right = '0px';
    element.style.height = '0px';
    element.style.width = '0px';
    element.style.zIndex = '9999999';
    element.style.transition = 'bottom 0.2s ease';
    element.setAttribute('allowTransparency', 'true');
    document.body.appendChild(element);

    if (!fixios) return element;

    // create hidden element to easly get viewport size
    element = document.createElement('div');
    element.className = 'widget-root';
    element.id = `${id}-calc`;
    element.style.cssText =
        'position: absolute; top: 0; bottom: 0; right: 0; left: 0; visibility: hidden; z-index: -999999;';
    document.body.appendChild(element);

    if (document.body.offsetHeight < element.offsetHeight) {
        document.body.style.height = `${element.offsetHeight}px`;
    }

    window.addEventListener(
        'resize',
        () => {
            repositionIframe();
        },
        true
    );
    window.addEventListener(
        'scroll',
        () => {
            if (!focusedElement) repositionIframe();
        },
        true
    );
    setInterval(() => {
        const iframe = Helpers.getIFrameElement();
        const newFocusedElement = iframe.contentWindow.document.querySelector(':focus');
        if (newFocusedElement) {
            const position = focusedElement ? focusedElement.getBoundingClientRect() : 0;
            const newPosition = newFocusedElement.getBoundingClientRect();
            if (
                position.top !== newPosition.top &&
                (newFocusedElement.tagName === 'INPUT' || newFocusedElement.tagName === 'TEXTAREA')
            ) {
                focusedElement = newFocusedElement;
                repositionIframe();
            }
        } else if (focusedElement) {
            repositionIframe();
            focusedElement = null;
        }
    }, 1000);

    return element;
};

export const resizeIFrame = ({ childWidth, childHeight, mode }) => {
    const iframe = Helpers.getIFrameElement();
    if (iframe) {
        if (childHeight) {
            iframe.style.height = childHeight + 'px';
        }
        if (childWidth) {
            iframe.style.width = childWidth + 'px';
        }
        Helpers.setIFrameMode(iframe, childWidth > 0 && childHeight > 0 ? mode : DISPLAY.NONE);
        repositionIframe();
    }
};

export const onWindowResize = () => {
    clearTimeout(Helpers.resizeTimer);
    Helpers.resizeTimer = setTimeout(function () {
        const documentSize = DOM.getDocumentSize();
        IPC.sendEvent(WIDGET_ACTIONS.RESIZE, {
            parentWidth: documentSize.width,
            parentHeight: documentSize.height
        });
    }, 250);
};

export const showIframeBorder = (show) => {
    const iframe = Helpers.getIFrameElement();

    if (show) {
        iframe.style.border = '2px solid red';
    } else {
        iframe.style.border = '0 solid red';
    }
};

let focusElementId;

export const setFocusToIFrame = () => {
    focusElementId =
        document.activeElement && document.activeElement.id ? document.activeElement.id : null;

    const iframe = document.getElementById(CommonConfig.iFrameId);
    if (iframe) {
        setTimeout(iframe.contentWindow.focus(), 0);
    }
};

export const returnFocusFromIFrame = () => {
    if (!focusElementId) {
        return;
    }

    const element = document.getElementById(focusElementId);
    if (element) {
        setTimeout(element.focus(), 0);
    }
};
